import { SolutionPage } from './SolutionPage'
import { solutionsData } from '@/data/solutions'

export default function Operations() {
  return <SolutionPage solution={solutionsData.operations!} />
}
